document.onreadystatechange = function () {
  var accordion_rows = Array.from(
    document.getElementsByClassName("jobs__job-header")
  );
  accordion_rows.forEach(function (element) {
    element.parentElement.querySelector(".jobs__job-description").style.maxHeight =
      "0px";

    element.onclick = function (event) {
      var row = event.currentTarget.parentElement;
      var body = row.querySelector(".jobs__job-description");
      if (row.classList.contains(".active")) {
        window.setTimeout(() => {
          body.style.maxHeight = "0px";
        }, 300);
      } else {
        body.style.maxHeight = body.scrollHeight + "px";
      }
      row.classList.toggle(".active");
    };
  });
};